
import { defineComponent, ref } from 'vue'

import Header from '@/components/Common/Header.vue'
import Footer from '@/components/Common/Footer.vue'

export default defineComponent({
    name: 'App',
    components: {
        Header,
        Footer,
    },
    setup() {
        const isMobileMenuOpen = ref(false)

        const toggleMobileMenuOpen = () => {
            isMobileMenuOpen.value = !isMobileMenuOpen.value
        }

        return {
            isMobileMenuOpen,
            toggleMobileMenuOpen,
        }
    },
})
